


const HASH = "SHA-256";
const ALGORITHH = "ECDSA";
const CURVE = "P-256";//r1

export class Device {
    KeyPair!: CryptoKeyPair;
    DeviceId!: string;
    UserName!: string;
    WorkSpace!: string;
    PublicKey!: string;
    PrivateKey!: string;

    async GetPublicKey() {

        if (this.KeyPair == undefined) {
            var tckp = await window.crypto.subtle.generateKey({
                name: ALGORITHH,
                namedCurve: CURVE,
            },
                false, ["sign"]
            );
            this.KeyPair = tckp;
        }

        var pk = await window.crypto.subtle.exportKey("spki", this.KeyPair.publicKey)

        let body:any = window.btoa(String.fromCharCode(...new Uint8Array(pk)));
        body = body.match(/.{1,64}/g).join('\n');
        body = "-----BEGIN PUBLIC KEY-----\n"+body+"\n-----END PUBLIC KEY-----\n"
        return body;
    }

    async getKeys() {

        if (this.KeyPair == undefined) {
            var tckp = await window.crypto.subtle.generateKey({
                name: ALGORITHH,
                namedCurve: CURVE,
            },
                true, ["sign"]
            );
            this.KeyPair = tckp;
        }

        var pub = await window.crypto.subtle.exportKey("spki", this.KeyPair.publicKey)
        let body:any = window.btoa(String.fromCharCode(...new Uint8Array(pub)));
        body = body.match(/.{1,64}/g).join('\n');
        body = "-----BEGIN PUBLIC KEY-----\n"+body+"\n-----END PUBLIC KEY-----\n"

        var pk = await window.crypto.subtle.exportKey("pkcs8", this.KeyPair.privateKey)
        let body1:any = window.btoa(String.fromCharCode(...new Uint8Array(pk)));
        body1 = body1.match(/.{1,64}/g).join('\n');
        body1 = "-----BEGIN PRIVATE KEY-----\n"+body1+"\n-----END PRIVATE KEY-----\n"

        var str = []
        str.push(body)
        str.push(body1)
        return str;
    }


}